import { Button, Dialog, DialogContent, Divider, Grow, Rating, TextField, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OEM } from 'utility/OEMProvider';
import { doFetchUserRatingAsync, doPostUserRatingAsync, doSetUserRating, selectUserRating } from '../user/userSlice';
import MDBox from 'components/MDBox';
import { resources } from 'oems/resources';
import MDButton from 'components/MDButton';

export default function RateAppDialog(props) {
  const dispatch = useDispatch();

  const userRating = useSelector(selectUserRating);

  const { onClose, selectedValue, open } = props;
  const [ratingValue, setRatingValue] = useState(0);
  const [showCommentTextField, setShowCommentTextField] = useState(false);
  const [commentValue, setCommentValue] = useState('');

  React.useEffect(() => {
    dispatch(doFetchUserRatingAsync());
  }, []);

  React.useEffect(() => {
    setRatingValue(userRating.rating);
    setShowCommentTextField(userRating.submitted);
    setCommentValue(userRating.comment);
    if (userRating.submitted) {
      setShowCommentTextField(userRating.comment.trim() != '');
    }
  }, [userRating]);

  const ratingChanged = (event, rating) => {
    if (rating !== null) {
      setShowCommentTextField(true);
      setRatingValue(rating);
    }
  };

  const handleClose = () => {
    if (userRating.submitted === false) {
      dispatch(doSetUserRating({ rating: 0, comment: '' }));
    }
    onClose(selectedValue);
  };

  const onStoreRatingClick = () => {
    dispatch(doPostUserRatingAsync({ rating: ratingValue, comment: commentValue }));
  };

  return (
    <Dialog
      onClose={handleClose}
      sx={{ flexGrow: 1, flexDirection: 'column' }}
      open={open}
      fullWidth={props.fullWidth}
      maxWidth={props.maxWidth}
    >
      <Box
        sx={{
          background: (theme) => {
            return theme.functions.linearGradient(
              theme.palette.gradients.dark.main,
              theme.palette.gradients.dark.state,
            );
          },
        }}
      >
        <Stack direction="row" justifyContent="flex-start" alignItems="center" sx={{ height: 48 }}>
          <MDBox component="img" src={resources.logoLightImage} width="100px" sx={{ ml: 1, my: 1 }} />
        </Stack>
      </Box>
      <Divider />
      <DialogContent>
        <Stack direction="column" justifyContent="center" alignItems="center" sx={{ m: 1 }}>
          {userRating.submitted === false ? (
            <Typography sx={{ mb: 1 }}>
              Czy polecił(a)byś usługę <strong>{OEM().ProductName}</strong>?
            </Typography>
          ) : (
            <Typography sx={{ mb: 1 }}>
              Dziękujemy za <strong>Twoją</strong> opinię!
            </Typography>
          )}
          <Rating
            name="half-rating"
            defaultValue={6}
            precision={1.0}
            max={10}
            value={ratingValue}
            size="large"
            onChange={ratingChanged}
            readOnly={userRating.submitted}
            sx={{ mb: 1 }}
          />

          {showCommentTextField ? (
            <Grow in={showCommentTextField}>
              <Box sx={{ display: 'flex', my: 1 }}>
                <TextField
                  placeholder={userRating.submitted === false ? 'Napisz opinię' : ''}
                  sx={{ width: 500 }}
                  multiline={true}
                  rows={5}
                  InputProps={{
                    readOnly: userRating.submitted,
                  }}
                  value={commentValue}
                  onChange={(event) => setCommentValue(event.target.value)}
                ></TextField>
              </Box>
            </Grow>
          ) : (
            <div></div>
          )}

          {userRating.submitted === false ? (
            <MDButton
              variant="contained"
              color="info"
              size="small"
              sx={{ width: 128, textTransform: 'none', mt: 1 }}
              onClick={onStoreRatingClick}
            >
              zapisz opinię
            </MDButton>
          ) : (
            <MDButton
              variant="contained"
              color="info"
              size="small"
              sx={{ width: 128, textTransform: 'none', mt: 1 }}
              onClick={handleClose}
            >
              zamknij
            </MDButton>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
